import styled from 'styled-components';
import device from '../../GlobalDigitalStyle/BreakPoint.style';
export const Header = styled.div`
	border-bottom: 1px solid #0000001a;
	padding: 1rem 0px 0;
	position: relative;
	background-color: #ffff;
	z-index: 999;
`;
export const UserPanel = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	width: 20%;
	justify-content: flex-end;
	gap: 50px;
	margin-right: 4px;
	@media ${device.screen1050} {
		gap: 15px;
	}
	.user-avatar {
		width: 3em;
		height: 3em;
		margin: 0 0 0.5em;
		cursor: pointer;
		border: 2px solid #01abc1;
		border-radius: 50%;
		img {
			background-color: #fff;
			border-radius: 50%;
		}
		@media (max-width: 1450px) {
			width: 2.5em;
			height: 2.5em;
		}
		@media ${device.screen1050} {
			width: 2em;
			height: 2em;
		}
	}
	.notification {
		width: auto;
		height: auto;
	}
`;
export const NavbarContainer = styled.div`
	width: 90%;
	margin: 0 auto;
	justify-content: space-between;
	display: flex;
	.linksContainer {
		align-items: flex-end;
		display: flex;
		justify-content: flex-start;
		gap: 3em;
		font-family: Manrope-Bold;
		@media (max-width: 1450px) {
			gap: 1.2em;
		}
		.logoImg {
			width: 15% !important;

			@media (max-width: 1450px) {
				margin-right: 1em;
			}
			@media ${device.screen1050} {
				width: 15% !important;
				margin-right: 0.5em;
				margin-bottom: 0.8em;
			}
		}

		.navLink {
			font-size: 1em;
			align-items: center;
			display: flex;
			gap: 8px;
			padding-bottom: 1.1em;
			text-decoration: none;
			filter: grayscale(100%);
			font-weight: 600;
			/* border-bottom: 2px solid transparent; */
			color: #989898;
			@media (max-width: 1450px) {
				font-size: 14px;
				padding-bottom: 1em;
			}
			@media ${device.screen1050} {
				font-size: 0.75em;
				gap: 4px;
			}
			&.active {
				filter: unset;
				/* border-bottom: 2px solid; */
				color: var(--main-color);
			}
			img {
				width: 22px;
				@media (max-width: 1450px) {
					width: 1em;
				}
				@media ${device.screen1050} {
					width: 0.875em;
				}
			}
		}
	}
`;

export const DropDown = styled.div`
	padding: 0.75rem;
	display: flex;
	gap: 1rem;

	.dropdownAvatar {
		border-radius: 50%;
	}
	.userInfo {
		display: flex;
		flex-direction: column;
	}
`;
